import { makeTA } from './TypeActions';

/**
 * Cooldown directive.
 *
 * Pass event names via modifiers - the directive will add listeners for
 * every event. When an event we care about is captured, the element will
 * be put into its cooldown state (default behavior is to set `disabled` to `true`).
 *
 * The duration of the cooldown period is set via the value (in milliseconds).
 *
 * Example: `<button v-cooldown.click="10000" @click="doSomething" />`
 */
export default {
  bind: (el, binding) => {
    // TODO: Add more custom behaviors for more elements.

    const event_list = (() => {
      const binding_events = Object.keys(binding.modifiers);
      if (binding_events.length > 0) {
        return binding_events;
      }
      return [`click`];
    })();
    event_list.forEach((event_name) => {
      el.addEventListener(event_name, async () => { // listen for every event in modifiers
        makeTA(el, binding).run();
      });
    });
  },
};
